module.exports = __webpack_public_path__ + "img/yingshu.398b20f8.jpg";